// components/PostSkeleton.jsx
import React from "react";
import "./skeleton.css";

const PostSkeleton = () => {
  return (
    <div className="skeleton-card">
      {/* Header */}
      <div className="skeleton-header">
        <div className="skeleton avatar"></div>
        <div className="skeleton-text-group">
          <div className="skeleton text short"></div>
          <div className="skeleton text smaller"></div>
        </div>
      </div>

      {/* Image */}
      <div className="skeleton image"></div>

      {/* Content */}
      <div className="skeleton text"></div>
      <div className="skeleton text"></div>
      <div className="skeleton text short"></div>

      {/* Footer */}
      <div className="skeleton-footer">
        <div className="skeleton button"></div>
        <div className="skeleton button"></div>
        <div className="skeleton button"></div>
      </div>
    </div>
  );
};

export default PostSkeleton;